/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const Waypoints = [
  ["path", { d: "m10.586 5.414-5.172 5.172" }],
  ["path", { d: "m18.586 13.414-5.172 5.172" }],
  ["path", { d: "M6 12h12" }],
  ["circle", { cx: "12", cy: "20", r: "2" }],
  ["circle", { cx: "12", cy: "4", r: "2" }],
  ["circle", { cx: "20", cy: "12", r: "2" }],
  ["circle", { cx: "4", cy: "12", r: "2" }]
];

export { Waypoints as default };
//# sourceMappingURL=waypoints.js.map
